export default __webpack_public_path__ + "static/media/icon_6.2d6b2e0b.png";